import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MeService } from './airbrush/me.service';
import { SessionService } from './session.service';
import { ListFilter, User } from '@parashift/shared/models';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {
  private meService = inject(MeService);
  private sessionService = inject(SessionService);

  private tenant_id: string;

  // Renew the per-tab tenant-scoped session token via GET /me/bearer (authed by the global/refresh
  // token). A tenant_id yields that tenant's bearer; no tenant_id yields the tenant-less global (mdt)
  // token. Deliberately never touches the tenant-less global (refresh) token. See WTF-8434.
  refresh() {
    if (this.sessionService.user_id) {
      this.meService.getBearer(this.buildFilter()).subscribe((me: User) => {
        this.sessionService.refreshSessionToken(me.bearer_token);
      });
    }
  }

  get(tenant_id?: string): Observable<User> {
    this.tenant_id = tenant_id;
    return this.meService.getBearer(this.buildFilter()).pipe(
      tap(me => this.sessionService.refreshSessionToken(me.bearer_token))
    );
  }

  private buildFilter(): ListFilter {
    const query_params = this.tenant_id ? { tenant_id: this.tenant_id } : {};
    return new ListFilter({ query_params });
  }
}
